module.exports = __webpack_public_path__ + "static/media/icon-nf.eaadfe88.svg";